import { render } from "./osaDetailsRow.vue?vue&type=template&id=38b6de32&scoped=true"
import script from "./osaDetailsRow.vue?vue&type=script&lang=js"
export * from "./osaDetailsRow.vue?vue&type=script&lang=js"

import "./osaDetailsRow.vue?vue&type=style&index=0&id=38b6de32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6de32"]])

export default __exports__